import { create } from "zustand";
import { useFetchProductCatlogSlice } from "../slices/ProductCatlogSlices/fetchProductCatlogSlices";

interface ProductCatlogInterface
  extends ReturnType<typeof useFetchProductCatlogSlice> {}

export const ProductCatlogStore = create<ProductCatlogInterface>((...a) => ({
  ...useFetchProductCatlogSlice(...a),
}));
